/**
 * pageExitGuard (2026-08-31): a one-slot registry that lets the CURRENT page
 * veto the AppShell header back button.
 *
 * The species page's Manual Edit mode must not be left while a form-tracked
 * variant is self-contradictory (topline ticked, no form picked - see
 * regionalLinkGuard). Done and swipe-away are the page's own handlers, but
 * the back button lives in AppShell, so the page registers a guard here for
 * exactly as long as edit mode is armed.
 *
 * The guard returns true to allow the navigation; returning false blocks it,
 * and the guard is expected to surface its own UI explaining why (the
 * resolve sheet). Deliberately one slot, last-writer-wins: only the mounted
 * page can meaningfully guard its own exit.
 */
type PageExitGuard = () => boolean;

let current: PageExitGuard | null = null;

/** Register a guard; returns the unregister function (use in an effect). */
export function registerPageExitGuard(guard: PageExitGuard): () => void {
  current = guard;
  return () => {
    if (current === guard) current = null;
  };
}

/** True when navigation may proceed (no guard, or the guard allowed it). */
export function confirmPageExit(): boolean {
  return current == null || current();
}
